module.exports = __webpack_public_path__ + "static/media/blue-l.f471208e.svg";